<!-- <app-signin-modal-form></app-signin-modal-form> -->
<app-signin-buttons></app-signin-buttons>

<div class="footer-link">
  Don't have an account?
  <div (click)="openSignUp()" class="link font-medium">Join for free</div>
</div>
